import React from 'react'
import NewsEventsCompo from '../../Component/NewsEvents/NewsEventsCompo'

const NewsandEvents = () => {
  return (
    <div className='page-body'>
        <NewsEventsCompo/>
    </div>
  )
}

export default NewsandEvents